/**
 * Created by Ning Jiang on 2024-04-18.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {TimelineLite} from "gsap";
import {DeadwoodRipS3Symbol} from "../../symbol/DeadwoodRipS3Symbol";
import {DeadwoodRipLSymbol} from "../../symbol/DeadwoodRipLSymbol";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";
import {DeadwoodRipBackground} from "../../view/DeadwoodRipBackground";

export class LowToWildController extends WinPresentationController {

    constructor() {
        super("LowToWildController", false);
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.lowTransformList && DeadwoodRip.model.parsedGameData.lowTransformList.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        DeadwoodRip.playScattersWin = true;
        const tl = new TimelineLite();
        const s1 = <DeadwoodRipS3Symbol>DeadwoodRip.reels[1].getSymbol(DeadwoodRip.model.parsedGameData.S3Positions[1]);
        const s2 = <DeadwoodRipS3Symbol>DeadwoodRip.reels[3].getSymbol(DeadwoodRip.model.parsedGameData.S3Positions[3]);
        tl.add([
            s1.playFeatureWin(),
            s2.playFeatureWin(),
            () => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.BADGE_LOW_TO_WILD});
            }
        ]);
        const updateDelay = 0.2;
        DeadwoodRip.model.parsedGameData.lowTransformList.forEach(l => {
            const sym = <DeadwoodRipLSymbol>DeadwoodRip.reels[l.reel].getSymbol(l.row);
            tl.add(sym.showWild(), updateDelay);
        });
        const wave = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("shootOutWave"));
        wave.autoUpdate = true;
        wave.position.set(360, 360);
        tl.add(() => {
            DeadwoodRipLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(wave);
            wave.state.setAnimation(0, "animation", false);
            DeadwoodRipBackground.shakeStageOnce(0.6);
        }, updateDelay);
        tl.add(() => {
            wave.state.setEmptyAnimations(0);
            wave.parent.removeChild(wave);
            wave.destroy();
        }, `+=${wave.spineData.findAnimation("animation").duration}`);
        return Promise.resolve(tl);
    }
}